import {
    AfterViewInit,
    Component,
    effect,
    inject,
    input,
    InputSignal,
    OnInit,
    output,
    ResourceRef,
    ViewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ContractDetails } from '../../models/contract-details';
import { AccountStore } from '../../store/account-store';
import { Contracts } from '../../models/contracts';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgStyle } from '@angular/common';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ShortenIdPipe } from '../../../../shared/pipes/shorten-id.pipe';

@Component({
    selector: 'app-list-of-contracts',
    imports: [
        MatCardModule,
        MatMenuModule,
        MatButtonModule,
        MatPaginatorModule,
        MatTableModule,
        NgxSkeletonLoaderModule,
        MatBadgeModule,
        MatTooltipModule,
        NgStyle,
        ShortenIdPipe,
    ],
    templateUrl: './list-of-contracts.component.html',
    styleUrl: './list-of-contracts.component.scss',
})
export class ListOfContractsComponent implements AfterViewInit {
    contractList: InputSignal<ContractDetails[] | undefined> = input();
    public store = inject(AccountStore);

    displayedColumns: string[] = [
        'contractId',
        'productCategory',
        'contractType',
        'statusDate',
        'contractRole',
    ];

    contractList1: Contracts[];

    contractResourceRef =
        input<
            ResourceRef<{ status: number; message: string; data: Contracts[] }>
        >();

    // dataSource = new MatTableDataSource<ContractDetails>([]);
    dataSource = new MatTableDataSource<Contracts>([]);

    @ViewChild(MatPaginator) paginator!: MatPaginator;

    contractEmitter = output<Contracts>();

    constructor() {
        effect(() => {
            this.updateTableData();
        });
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }

    updateTableData() {
        const resourceRef = this.store.computedContractResource();
        if (resourceRef && !resourceRef.isLoading() && resourceRef.value()) {
            this.dataSource.data = resourceRef.value()?.data || [];
        }
    }

    showEvents(contract: Contracts) {
        this.contractEmitter.emit(contract);
    }

    active = true;
    inactive = true;

    getTheme() {
        return {
            'border-radius': '5px',
            height: '256px',
            width: '100%',
            'background-color': 'rgba(117, 127, 239, 0.1)',
        };
    }
}
